import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './ErrorUpdateAllOutletModal.css';

const ErrorUpdateAllOutletModal = props => {
  const { show, onConfirmModal } = props;
  return (
    <Modal className={styles['modal-container']} show={show}>
      <Modal.Header>
        <Modal.Title className={styles['modal-title']}>
          Can't Update to All Outlets
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          We're is on process saving this product to all outlets. Please wait
          for a moment until the process is finished and try again.
        </div>
      </Modal.Body>
      <Modal.Footer>
        <span className="pull-right">
          <button
            className={`${styles['modal-button']}  btn btn-primary`}
            onClick={onConfirmModal}
          >
            OK
          </button>
        </span>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorUpdateAllOutletModal;
